import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=180766b8&"
import script from "./Audio.vue?vue&type=script&lang=ts&"
export * from "./Audio.vue?vue&type=script&lang=ts&"
import style0 from "./Audio.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports